module.exports = __webpack_public_path__ + "static/headshot-mike-myers-2x.def246d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-mike-myers-2x.jpg
// module id = 129
// module chunks = 35783957827783 152909308826437